export interface ExportColumn {
  key: string;
  header: string;
}

export const ALL_EXPORT_COLUMNS: ExportColumn[] = [
  { key: "row_type", header: "Row Type" },
  { key: "name", header: "Name" },
  { key: "primary_type", header: "Type" },
  { key: "address", header: "Address" },
  { key: "lat", header: "Latitude" },
  { key: "lng", header: "Longitude" },
  { key: "rating", header: "Rating" },
  { key: "user_rating_count", header: "Rating Count" },
  { key: "ownership", header: "Ownership" },
  { key: "phone", header: "Phone" },
  { key: "website", header: "Website" },
  { key: "hours", header: "Hours" },
  { key: "business_status", header: "Business Status" },
  { key: "google_maps_url", header: "Google Maps URL" },
  { key: "place_id", header: "Place ID" },
  { key: "types", header: "Types" },
  { key: "has_sport_field", header: "Has Sport Field" },
  { key: "confidence", header: "Confidence" },
  { key: "classification_source", header: "Classification Source" },
  { key: "source", header: "Source" },
  { key: "approved_by_city", header: "Approved by City" },
  { key: "approved_by_sponsor", header: "Approved by Sponsor" },
  { key: "visibility_rating", header: "Rating" },
  { key: "is_cultural_spot", header: "Is Cultural Spot" },
  { key: "ownership_confirmed", header: "Ownership Confirmed" },
  { key: "user_notes", header: "User Notes" },
  { key: "sport_court_type", header: "Sport Court Type" },
  { key: "sport_court_notes", header: "Sport Court Notes" },
];

export const DEFAULT_EXPORT_COLUMNS: ExportColumn[] = ALL_EXPORT_COLUMNS.filter(
  (c) =>
    [
      "row_type",
      "name",
      "primary_type",
      "address",
      "lat",
      "lng",
      "rating",
      "ownership",
      "has_sport_field",
      "confidence",
      "source",
      "sport_court_type",
    ].includes(c.key),
);

export function escapeCSVValue(value: unknown): string {
  if (value == null) return "";
  let str = Array.isArray(value) ? value.join("; ") : String(value);
  // CSV injection protection: prefix dangerous characters with a single quote
  if (/^[=+\-@]/.test(str)) {
    str = `'${str}`;
  }
  if (str.includes(",") || str.includes('"') || str.includes("\n")) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function generateCSV(
  rows: Record<string, unknown>[],
  columns: ExportColumn[],
): string {
  const header = columns.map((c) => escapeCSVValue(c.header)).join(",");
  const dataRows = rows.map((row) =>
    columns.map((c) => escapeCSVValue(row[c.key])).join(","),
  );
  return [header, ...dataRows].join("\n");
}
